import mixitup from 'mixitup'
import mixitupMultifilter from '../mixitup-multifilter.min'
import mixitupPagination from '../mixitup-pagination.min'

mixitup.use(mixitupMultifilter)
mixitup.use(mixitupPagination)

let mixer
const containerId = 'mixitup-container'

const Multifilter = {
  getContainer: function() {
    const container = document.getElementById(containerId)
    return container
  },

  closeControls: function() {
    const fieldGroups = document.querySelectorAll('fieldset')
    fieldGroups.forEach(fieldGroup => fieldGroup.classList.remove('active'))
  },

  handleControls: function(e) {
    if (e.target.matches('fieldset:not(.active)')) this.closeControls()

    if (e.target.matches('fieldset')) {
      e.target.classList.toggle('active')
    } else {
      this.closeControls()
    }

  },

  buildFilters: function() {
    const container = this.getContainer(),
          items = container.querySelectorAll('.mix')

    let result = {
      'filter': {},
      'sort': {}
    }

    items.forEach(item => {
      Object.keys(item.dataset).forEach(function(key) {
        if (key !== 'search') {
          const values = item.dataset[key].split('__'),
              type = key.includes('filter') ? 'filter' : 'sort',
              group = key.replace(type, '')

          if (group in result[type] == false) {
            result[type][group] = []
          }

          values.forEach(value => {
            let index = result[type][group].findIndex(el => el.value == value)

            if (index < 0) {
              index = result[type][group].length
              result[type][group][index] = { class: `${type}-${group.toLocaleLowerCase()}-${index}`, value }
            }

            item.classList.add(`${type}-${group.toLowerCase()}-${index}`)
          });
        }
      })
    })

    let show = false
    Object.keys(result).forEach(key => {
      if (Object.keys(result[key]).length) {
        show = true
        this.addControls(key, result[key])
      }
    })

    //console.log(show)

    return show
  },

  sortObjectKeys: function(data) {
    const sorted = Object.keys(data).sort().reduce((accumulator, key) => {
        accumulator[key] = data[key];
        return accumulator;
    }, {});

    return sorted
  },

  sortObjectValues: function(data) {
    const sorted = data.sort((a, b) => {
      if (a.value < b.value) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      }
      return 0;
    })
    return sorted
  },

  reset: function() {
    const checkboxes = document.querySelectorAll('.fieldset-checkbox')
    checkboxes.forEach(item => item.checked = false)

    mixer.filter('all')
    mixer.sort('sort-newest:desc')

    this.resetSearch()
  },

  cleanFilters: function() {
    const checkboxes = document.querySelectorAll('.fieldset-checkbox')
    checkboxes.forEach(item => item.checked = false)
  },

  addControls: function(type, data) {
    const mainWrapper = document.querySelector('.filter-controls'),
          groupWrapper = mainWrapper.querySelector(`#${type}-group`)

    if (type == 'sort') {
      const sorted = this.sortObjectKeys(data)

      if (Object.keys(sorted).length < 2) return

      const fieldset = document.createElement('fieldset')
      fieldset.setAttribute(`data-${type}-group`, '')
      const title = document.createElement('div')
      title.classList.add('fieldset-title')
      title.innerHTML = `sort by <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1.5L5 5.5L9 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>`
      fieldset.appendChild(title)

      const options = document.createElement('div')
      options.classList.add('group-options')

      Object.keys(sorted).forEach(key => {
        const el = document.createElement('label')
        const span = document.createElement('span')
        span.setAttribute('data-sort', `sort-${key.toLocaleLowerCase()}:desc`)
        span.innerText = key
        el.appendChild(span)
        options.appendChild(el)
      })

      fieldset.appendChild(options)

      groupWrapper.appendChild(fieldset)
    }

    if (type == 'filter') {
      const sorted = this.sortObjectKeys(data)

      Object.keys(sorted).forEach(key => {
        const fieldset = document.createElement('fieldset')
        fieldset.setAttribute(`data-${type}-group`, '')
        const title = document.createElement('div')
        title.classList.add('fieldset-title')
        title.innerHTML = `${key} <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1.5L5 5.5L9 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>`
        fieldset.appendChild(title)

        const values = this.sortObjectValues(sorted[key])

        const options = document.createElement('div')
        options.classList.add('group-options')

        values.forEach(item => {
          const label = document.createElement('label')
          const span = document.createElement('span')
          const input = document.createElement('input')
          input.value = `.${item.class}`
          input.setAttribute('type', 'checkbox')
          input.classList.add('fieldset-checkbox')
          span.innerText = item.value
          label.appendChild(input)
          label.appendChild(span)
          options.appendChild(label)
        })

        fieldset.appendChild(options)

        groupWrapper.appendChild(fieldset)
      })
    }
  },

  toggleFilter: function() {
    const container = this.getContainer()
    container.classList.toggle('active')
  },

  resetSearch: function() {
    const searchInput = document.getElementById('filter-search-query'),
          placeholder = searchInput?.dataset.placeholder

    searchInput.innerHTML = searchInput?.dataset.placeholder
    searchInput.classList.remove('edit')
    searchInput.classList.add('empty')
  },

  registerSearch: function() {
    const searchInput = document.getElementById('filter-search-query'),
          placeholder = searchInput?.dataset.placeholder

    if (!searchInput) return

    searchInput.addEventListener('input', () => {
      if (searchInput.innerHTML) {
        mixer.filter(`[title*="${searchInput.innerHTML.toLowerCase()}"]`)
        this.cleanFilters()
      } else {
        mixer.filter('all')
      }
    })

    document.addEventListener('click', e => {
      if (e.target.matches('#filter-search-query')) {
        searchInput.setAttribute('contenteditable', true)
        setTimeout(function() {
          searchInput.focus()
        }, 0);

        searchInput.classList.add('edit')
        searchInput.classList.remove('empty')
        if (searchInput.innerHTML == placeholder) {
          searchInput.innerHTML = ''
        }
      } else {
        if (!searchInput.classList.contains('edit')) return
        searchInput.setAttribute('contenteditable', false)
        searchInput.classList.remove('edit')
        if (searchInput.innerHTML.trim() == '') this.resetSearch()
      }
    })
  },

  buildNavigation: function() {
    const container = this.getContainer()

    const nav = container.querySelector('.filter-nav')
    const navTop = container.querySelector('.filter-nav-top')
    nav.classList.add('active')

    const observer = new IntersectionObserver(
      ([e]) => nav.classList.toggle('is-sticky', e.intersectionRatio < 1),
      { threshold: [1] }
    )
    observer.observe(navTop)

    const toggles = document.querySelectorAll('.filter-toggle')
    toggles.forEach(toggle => {
      toggle.addEventListener('click', () => this.toggleFilter())
    })

    const overlay = document.querySelector('.filter-page-overlay')
    overlay.addEventListener('click', () => this.toggleFilter())

    const reset = document.querySelector('.filter-reset')
    reset.addEventListener('click', () => this.reset())

    nav.addEventListener('click', e => {
      if (!e.target.matches('.selected-value')) return

      const target = e.target.dataset.filterTarget

      if (target == 'all') {
        this.reset()
        return
      }

      const input = document.querySelector(`.fieldset-checkbox[value="${target}"`)
      input.click()
    })
  },

  handleMixEnd: function() {
    // build selected list
    const wrapper = document.querySelector('.filter-nav-selected')
    const selected = document.querySelectorAll('.fieldset-checkbox')

    if (!selected) return

    wrapper.innerHTML = ''

    let clearAll = false

    selected.forEach(input => {
      if (!input.checked) return

      const label = input?.nextSibling

      if (!label) return

      const el = document.createElement('div')
      el.classList.add('selected-value')
      el.setAttribute('data-filter-target', input.value)
      el.innerHTML =
      `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.53516 11.0356L10.6062 3.96458" stroke="#07396F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
      <path d="M10.6062 11.0354L3.53516 3.96436" stroke="#07396F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
      </svg>
      ${label.innerText}`
      wrapper.prepend(el)
      clearAll = true
    })

    if (!clearAll) return

    const el = document.createElement('div')
    el.classList.add('selected-value')
    el.setAttribute('data-filter-target', 'all')
    el.innerHTML = 'Clear all'

    wrapper.prepend(el)
  },

  checkFeaturedAdvertisement: function() {
    const ads = document.querySelectorAll('.featured-advertisement')
    if (!ads) return

    const container = document.querySelector('.box-list.blog-articles')
    if (!container) return

    const articles = container.querySelectorAll('.box-item')

    ads.forEach(ad => {
      let initPosition = +ad.getAttribute('card-position')

      let position = initPosition >= 1 ? initPosition - 1 : initPosition
      if (position >= articles.length) position = articles.length - 1

      let targetElement = articles[position]
      let insertElement = targetElement

      if (initPosition > articles.length) insertElement = insertElement.nextSibling

      const el = ad.cloneNode(true)
      // el.classList.add('mix')
      targetElement.parentNode.insertBefore(el, insertElement)
      ad.remove()
    })
  },

  init: function() {
    const container = this.getContainer()
    const limit = 16

    this.checkFeaturedAdvertisement()

    if (!container) return

    const showFilters = this.buildFilters()

    const arrowPrev =
    `<svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.2891 8.96716L2.00167 8.96716" stroke="#07396F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
      <path d="M10.0078 0.999917L2.00146 8.96724L10.0078 16.9346" stroke="#07396F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
    </svg>`

    const arrowNext =
    `<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 8.96741L18.2874 8.96741" stroke="#07396F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
    <path d="M10.2812 16.9347L18.2876 8.96733L10.2812 1" stroke="#07396F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
    </svg>`

    if (!container) return

    mixer = mixitup(container, {
      callbacks: {
        onMixEnd: () => this.handleMixEnd()
      },
      multifilter: {
        enable: true
      },
      pagination: {
        limit: limit,
        hidePageListIfSinglePage: true
      },
      templates: {
        pagerPrev: `<button type="button" class="mixitup-control mixitup-control-prev arrow" data-page="prev">${arrowPrev}</button>`,
        pagerNext: `<button type="button" class="mixitup-control mixitup-control-next arrow" data-page="next">${arrowNext}</button>`
      }
    })
    this.registerSearch()

    const checkboxes = document.querySelectorAll('.fieldset-checkbox')
    checkboxes.forEach(checkbox => checkbox.addEventListener('change', () => this.resetSearch()))

    if (!showFilters) return

    document.addEventListener('click', e => this.handleControls(e))
    this.buildNavigation()

    $('#sort-group label').on('click', function() {
      if ( $(this).children('span[data-sort="sort-popularity:desc"]').length != 0 ) {
        mixer.sort('sort-popularity:desc');
      }
      if ( $(this).children('span[data-sort="sort-newest:desc"]').length != 0 ) {
        mixer.sort('sort-newest:desc');
      }

    })


  }
}

export default Multifilter
